import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppIcons } from 'app/modules/shared/app.icons';
import { AppSettings } from 'app/modules/shared/app.settings';
import { Language } from 'app/modules/shared/models/language';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { InputNumberModule } from 'primeng/inputnumber';

@Component({
  selector: 'app-input-double',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, InputNumberModule],
  templateUrl: './input-double.component.html',
  styleUrl: './input-double.component.scss'
})
export class InputDoubleComponent implements OnInit {
    @Input() field: any;
    formName: FormGroup;
    @Input() attributeLabels: [];
    @Input() moduleName: string;
    placeholder: any = null;
    unit: string = '';
    language: Language;
    languageCode: string;
    miIcons = AppIcons;
  
    constructor(private formGroupDirective: FormGroupDirective,
      public cs: CommonBindingDataService) {
      this.formName = this.formGroupDirective.control;
      this.language = JSON.parse(localStorage.getItem(AppSettings.LANGUAGE));
      this.languageCode = this.language[0].langCode;
    }
  
    ngOnInit() {
      // this.placeholder = this.cs.getLabelValue(this.moduleName + '.fields.' + this.field.attributeCode + '.placeholder', this.attributeLabels, this.field.attributeCode);
      this.placeholder = this.cs.getLabel('settings.lbl_enter_value');
    }
}
